export class DenialRequest {
	denialUidK: number;
	countedQ: number;
	cdsId: string;
	subDivisionUidK: number;
	bkWarehouseUidD: number;
	partWhUidK: number;
}

